import { Check, Clock, AlertTriangle } from "lucide-react";

export function MilestoneTimeline({ milestones = [] }) {
  return (
    <div className="relative pl-1">
      {milestones.map((m, i) => {
        const last = i === milestones.length - 1;
        const done = m.state === "done";
        const active = m.state === "active";
        return (
          <div key={m.key} className="relative flex gap-3 pb-5" data-testid={`milestone-${i}`}>
            {!last && (
              <span
                className={`absolute left-[11px] top-6 bottom-0 w-0.5 ${done ? "bg-emerald-300" : "bg-slate-200"}`}
              />
            )}
            <div
              className={`relative z-10 h-6 w-6 rounded-full flex items-center justify-center border-2 shrink-0 ${
                done
                  ? "bg-emerald-500 border-emerald-500"
                  : active
                  ? "bg-white border-indigo-500 pulse-dot"
                  : "bg-white border-slate-300"
              }`}
            >
              {done ? (
                <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />
              ) : active ? (
                <Clock className="h-3 w-3 text-indigo-600" strokeWidth={2.5} />
              ) : (
                <span className="h-1.5 w-1.5 rounded-full bg-slate-300" />
              )}
            </div>
            <div className="flex-1 -mt-0.5">
              <div className="flex items-center justify-between gap-2">
                <span className={`text-sm font-medium ${done ? "text-slate-500" : active ? "text-slate-900 font-semibold" : "text-slate-400"}`}>
                  {m.key}
                </span>
                <span className="text-[11px] font-mono-num text-slate-400 whitespace-nowrap">
                  {m.actual ? m.actual : m.planned}
                </span>
              </div>
              {m.note && (
                <div className="mt-1 flex items-start gap-1 text-[12px] text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1">
                  <AlertTriangle className="h-3 w-3 mt-0.5 shrink-0" />
                  {m.note}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
